import { Link } from 'react-router-dom';
import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';
import './Header.css';

export default function Header() {
  return (
    <header className="dh-header">
      <div className="dh-container dh-header__inner">
        <Link to="/" className="dh-logo">{SITE_NAME}</Link>
        <nav className="dh-header__nav" aria-label="Primary">
          <a href="#products">Products</a>
          <a href="#support">Support</a>
          <a href="#faq">FAQs</a>
          <button type="button" className="dh-header__cta" onClick={openZohoChat}>
            Get Started
          </button>
        </nav>
        <button
          type="button"
          className="dh-header__chat-mobile"
          onClick={openZohoChat}
          aria-label="Open live chat"
        >
          Chat
        </button>
      </div>
    </header>
  );
}
